const FETCH_ALL_PENDING = "FETCH_ALL_ROLES_PENDING";
const FETCH_ALL_SUCCESS = "FETCH_ALL_ROLES_SUCCESS";
const FETCH_ALL_ERROR = "FETCH_ALL_ROLES_ERROR";

export default {
  FETCH_ALL_PENDING,
  FETCH_ALL_SUCCESS,
  FETCH_ALL_ERROR,
};
